
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http'; // Removed HttpHeaders import
import { Observable } from 'rxjs';
import { environment } from 'projects/foreign-admits/src/environments/environment';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerService { 
  private baseUrl: string = environment.apiBaseUrl;
  constructor(private http: HttpClient, private apiHelperService: ApiHelperService) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
  }

  getPartnerLogo(puid: string): Promise<any> {
    const headers = this.getAuthHeaders();
    return this.apiHelperService.getDataWithShortlistingUrl(`partner-details/get-partner-logo/${puid}`);
  }

  // loginPartner(credentials: any): Observable<any> {
  //   return this.http.post(`${this.baseUrl}/token/`, credentials);
  // }

  // getPartnerStudents(): Observable<any> {
  //   return this.http.get(`${this.baseUrl}/partner/dashboard/`); // Removed headers
  // }
}

